module.exports = __webpack_public_path__ + "img/02.ff85c808.jpg";